<template>
	    <!-- 批量更改弹窗 -->
	<div v-if="data.isShow">
	    <div class="mask batch-change">
	        <div class="e-modal medium">
	            <div class="e-modal-title">Batch update <i class="e-modal-close" @click="data.isShow=false"></i></div>
	            <div class="e-modal-body">
	            	<div class="emb-list">
	            		<div class="embl-head">
	            				<label for="embl-chb">
	                        		<input id="embl-chb" type="checkbox"  v-model="checkedAll"/>All
	                        	</label> 
	                        	<a href="javascript:void(0)" style="margin-left:20px;" @click="checkedAllCancel">Clear</a>
	            		</div>
	            		<div class="embl-content" v-for="(room,index) in roomList">
		            		<div class="embl-left">
		            			<label :for="room.RPS[0].RateId+room.RPS[0].RoomId">
		            				<input :id="room.RPS[0].RateId+room.RPS[0].RoomId" type="checkbox" @change="checkboxChange(room)" v-model="room.checked" :disabled="room.scope">{{room.NameEn||room.Name}}
		            			</label>
											<label style="margin-top: 10px;font-size: 14px;display: block;">
	                      <input type="radio" v-model="room.IsShared" value="true" :disabled="(room.RPS.length<2)" @change="checkRoomScope(room,true)"/> RoomType(Shared)
	                    </label>
											<label style="margin-top: 10px;font-size: 14px;display: block;">
												<input type="radio" v-model="room.IsShared" value="false" @change="checkRoomScope(room,false)"/> RatePlan(Independent)
											</label>
		            			
		            		</div>
		            		<div class="embl-right" >
		            			<div class="emblr-tag" v-for="(rps,index) in room.RPS">
		            				<label :for="rps.RateId">
		            					<input :id="rps.RateId" type="checkbox"  v-model="rps.active"  :disabled="rps.scope"/>
		            				{{rps.PriceTypeName+'&nbsp;&nbsp;&nbsp;'+ (rps.EnRatePlanName||rps.RatePlanName)}}</label>
		            			</div>
		            		
		            		</div>	
	            		</div>

	            	</div>

	                <ul class="change-type">
	                    <li :class="isActivePage=='custom'?'active':''" @click="isActivePage='custom'">Adjust custom</li>
	                    <li :class="isActivePage=='month'?'active':''" @click="isActivePage='month'">Adjust by month</li>
	                    <li :class="isActivePage=='timeSlot'?'active':''" @click="isActivePage='timeSlot'">Adjust by time</li>
	                </ul>


	                <!-- type-content -->
	                  <!-- //自定义调整 -->
	                <div :class="isActivePage=='custom'?'type-content active':'type-content'"  >
	                    <div class="left">
	                    	<datePicker  @on-date-chage="onDateChange" ></datePicker>
	                    </div>
	                    <div class="right">
	                        <div class="body-item" v-if="!cuHideRoomStatus">
	                        	<span class="label" style="width: 75px">Status： </span>
	                        	<label for="customStateOpen">
	                        		<input type="radio" name="roomState" id="customStateOpen" v-model="cuIsOpen" :value="true" />Open
	                        	</label>
	                        	<label for="customStateClose">
	                        		<input type="radio" name="roomState" id="customStateClose" v-model="cuIsOpen" :value="false" />Close
	                        	</label>
														<div class="body-item">
															<span class="label" style="width: 75px"></span>
															<label><input type="checkbox" v-model="cuHideRoomCount" style="margin-top: 15px;">Only modify the room status</label>
														</div>
														
	                        </div>

	                        <div class="body-item" v-if="!cuHideRoomCount">
	                        	<span class="label" style="width: 75px">Count： </span>
	                        	<label for="customCount">
	                        		<input type="radio" name="roomCount" id="customCount" v-model="cuIsAsk" :value="true" />R 
	                        	</label>
	                        	<label for="customCountText">
	                        		<input type="radio" name="roomCount" id="customCountText" v-model="cuIsAsk" :value="false" />
	                        		<!-- <input type="text" v-model="cuCount" /> -->
	                        		<input type="text"  v-model="cuCount" maxlength="2" onKeyPress="if((event.keyCode<48 || event.keyCode>57))event.returnValue=false"   onkeyup="value=value.replace(/[\u4e00-\u9fa5]/g,'')"   v-if="cuIsAsk==false"/>
	                						<input type="text"  v-if="cuIsAsk==true" readonly="readonly" />
	                        	</label>
														<label for="customAllowOverSell" style="font-size: 14px;">
																<input  type="checkbox" id='customAllowOverSell' v-model="cuAllowOver"  v-if="cuIsAsk==false">
																<input type="checkbox"  v-if="cuIsAsk==true" disabled="disabled" />
																Allowed to Overbook
														</label>
														<div v-if="!cuIsAsk" style="color:red;padding: 5px 5px 0px 120px;font-size: 14px;">{{cuNumText}}</div>
														<div class="body-item">
															<span class="label" style="width: 75px"></span>
															<label><input type="checkbox" v-model="cuHideRoomStatus" style="margin-top: 15px;">Only Modify the Room Inventory</label>
														</div>
	                        </div>
	                    </div>
	                </div>



  
	                <!-- type-content -->
	                 <!-- //按月调整 -->
	                <div :class="isActivePage=='month'?'type-content active':'type-content'" >
	                    <div class="choose-date">
	                        <div class="select">
	        					<select name="year" v-model="year">
		                            <option :value="year" v-for="year in years" >{{year}}</option>
		                        </select>
	                        </div>
	                        <a href="javascript:void(0)" class="arrow-left" @click="lastMonth"></a>                        
	                        <div class="select" >
		                        <select name="month" v-model="month" >
		                            <option :value="month" v-for="month in ['01','02','03','04','05','06','07','08','09','10','11','12']">{{month}}</option>
		                        </select>
	                        </div>
	                        <a href="javascript:void(0)" class="arrow-right" @click="nextMonth"></a>                        
	                    </div>
	                    <div class="body-item">
	                        <span class="label" style="width: 75px">Week：</span>
	                        <template v-for="(day,index) in WeekDays2">
	    						<label :for="'day-label'+index">
	    							<input :id="'day-label'+index" type="checkbox" :checked="day.checked"  @click="day.checked=!day.checked">{{day.name}}
	    						</label>
    						</template>
	                    </div>
	                    <div class="body-item">
	                        <span class="label" style="width: 75px">Status：</span>
	                        <label for="monthState11"><input type="radio" name="monthState" id="monthState11" v-model="moIsOpen" :value="true">Open</label>
	                        <label for="monthState12"><input type="radio" name="monthState" id="monthState12" v-model="moIsOpen" :value="false">Close</label>
													<div class="body-item">
														<span class="label" style="width: 75px"></span>
														<label><input type="checkbox" v-model="moHideRoomCount" style="margin-top: 15px;">Only modify the room status</label>
													</div>
	                    </div>
	                    <div class="body-item" v-if="!moHideRoomCount">
	                        <span class="label" style="width: 75px">Count：</span>
	                        <label for="monthState21">
	                        	<input type="radio" name="monthCount" id="monthState21" v-model="moIsAsk" :value="true">R 
	                        </label>
	                        <label for="monthState22">
	                        	<input type="radio" name="monthCount" id="monthState22" v-model="moIsAsk" :value="false">

	                        	<input type="text"  v-model="moCount"  v-if="moIsAsk==false"  maxlength="2" onKeyPress="if((event.keyCode<48 || event.keyCode>57))event.returnValue=false"   onkeyup="value=value.replace(/[\u4e00-\u9fa5]/g,'')"   />
	                					<input type="text"  v-if="moIsAsk==true" readonly="readonly" />
	                        </label>

													<label for="moAllowOver">
															<input  type="checkbox" id='moAllowOver' v-model="moAllowOver"  v-if="moIsAsk==false">
															<input type="checkbox"  v-if="moIsAsk==true" disabled="disabled" />
															Allowed to Overbook
													</label>
													<div v-if="!moIsAsk" style="color:red;padding: 5px 5px 0px 120px;">{{moNumText}}</div>

													<div class="body-item">
															<span class="label" style="width: 75px"></span>
															<label><input type="checkbox" v-model="moHideRoomStatus" style="margin-top: 15px;">Only Modify the Room Inventory</label>
													</div>
	                    </div>
	                </div>



	                <!-- type-content -->
	                 <!-- // 时间段调整 -->
	                <div :class="isActivePage=='timeSlot'?'type-content active':'type-content'" >
	                    <div class="body-item">
	                        <span class="label">Date：</span>
	                        <label for="" class="calendar-position">
	                        	<input type="text" class="date-choose-input calendarBegin" v-model="beginSlot" name="date" @click="calendar.show=true">
	                        	<input type="text" class="date-choose-input calendarEnd"  v-model="endSlot" @click="calendar2.show=true"  name="date">
	                        </label>
	                          <calendar v-if="calendar.show" :zero="calendar.zero" :lunar="calendar.lunar" :value="calendar.value" :begin="calendar.begin"  @select="calendar.select"></calendar>
	                        <calendar style="margin-left:204px"  v-if="calendar2.show" :zero="calendar2.zero" :lunar="calendar2.lunar" :value="calendar2.value" :begin="calendar2.begin"  @select="calendar2.select"></calendar>

	                        <!-- <calendar v-if="calendar.show" :events="calendar.events" :range="calendar.range" :begin="calendar.begin" :zero="calendar.zero" :lunar="calendar.lunar" :value="calendar.value"  @select="calendar.select">
                					</calendar> -->
	                    </div>
	                    <div class="body-item">
	                        <span class="label" style="width: 75px">Week：</span>
	                        <label v-for="(day,index) in WeekDays3" :for="'days-label'+index"><input :id="'days-label'+index" type="checkbox" :checked="day.checked"  @click="day.checked=!day.checked">{{day.name}}</label>
	                       
	                    </div> 

	   	           		<div class="body-item">
                            <span class="label" style="width: 75px">Exclude：</span>
                            <label for="" >
                            	<input type="text" class="date-choose-input" name="date" v-model="beginSlotExcept" @click="calendar3.show=true">
                            	<input type="text" class="date-choose-input" name="date" id="dateEnd2" v-model="endSlotExcept" @click="calendar4.show=true">
                            </label>
							<calendar v-if="calendar3.show" :zero="calendar3.zero" :lunar="calendar3.lunar" :value="calendar3.value" :begin="calendar3.begin" :end="calendar3.end"  @select="calendar3.select" ></calendar>
	                        <calendar style="margin-left:204px"  v-if="calendar4.show" :zero="calendar4.zero" :lunar="calendar4.lunar" :value="calendar4.value" :begin="calendar4.begin" :end="calendar4.end" @select="calendar4.select"></calendar>



                         	
                        </div>

	                    <div class="body-item">
	                        <span class="label" style="width: 75px">Status：</span>
	                        <label for="slotState1"><input type="radio" name="slotState" id="slotState1" v-model="IsOpen" :value="true" />Open</label>
	                        <label for="slotState2"><input type="radio" name="slotState" id="slotState2" v-model="IsOpen" :value="false" />Close</label>
													<div class="body-item">
														<span class="label" style="width: 75px"></span>
														<label><input type="checkbox" v-model="hideRoomCount" style="margin-top: 15px;">Only modify the room status</label>
													</div>
	                    </div>
	                    <div class="body-item" v-if="!hideRoomCount">
	                        <span class="label" style="width: 75px">Count：</span>
	                        <label for="slotCount1"><input type="radio" name="slotCount" id="slotCount1" v-model="IsAsk" :value="true"/>R </label>
	                        <label for="slotCount2">
	                        	<input type="radio" name="slotCount" id="slotCount2" v-model="IsAsk" :value="false" />
	                        	<input type="text"  v-model="Count"  v-if="IsAsk==false"  maxlength="2" onKeyPress="if((event.keyCode<48 || event.keyCode>57))event.returnValue=false"   onkeyup="value=value.replace(/[\u4e00-\u9fa5]/g,'')"   />
	                			<input type="text"  v-if="IsAsk==true" readonly="readonly" />
	                        </label>
	                        <label for="slotAllowOverSell1">
	                        	<input  type="checkbox" id='slotAllowOverSell1' v-model="AllowOver"  v-if="IsAsk==false">
	                					<input type="checkbox"  v-if="IsAsk==true" disabled="disabled" />
	                       		Allowed to Overbook
	                   			</label>
													<div v-if="!IsAsk" style="color:red;padding:5px 5px 0px 120px;">{{NumText}}</div>
													<div class="body-item">
															<span class="label" style="width: 75px"></span>
															<label><input type="checkbox" v-model="hideRoomStatus" style="margin-top: 15px;">Only Modify the Room Inventory</label>
													</div>
	                    </div>
	                </div> 
	            </div>
	            <div class="e-modal-footer">
	                <div class="short-btn save-btn" @click="save">save</div>
	                <div class="short-btn cancel-btn" @click="data.isShow=false">cancel</div>                                
	            </div>
	        </div>
	    </div>
	</div>
	
</template>

<script>
import datePicker from './../DatePicker.vue'
import Calendar from './../../../../common/calendar/calendar.vue'//日期选择器
export default {
    name:'roomStatusBatch',
    components:{
    	datePicker,
    	Calendar
    },
    props:{
    	cmData:{
    		type:Object,
    		default:function(){
    			return{}
    		}
    	},
    	rps:{
    		type:Object,
    		default:function(){
    			return{}
    		}
    	},
    	cmroomList:{
    		type:Array,
    		default:function(){
    			return[]
    		}
    	}
    },
    data(){
    	return{
    		data:{},
    		hotelId:this.dao.get('HotelId'),
    		isActivePage:"custom",
    		years:this.getYears(),
    		year:this.getYears()[0],
    		month:this.getMonth(),
				hideRoomCount:false,
				cuHideRoomCount:false,
				moHideRoomCount:false,
				hideRoomStatus:false,
				cuHideRoomStatus:false,
				moHideRoomStatus:false,
    		beginSlot:'',
    		endSlot:'',
    		WeekDaysSlot:[1,2,3,4,5,6,0],
				DateRangeDates:'',
				Count:0,
				IsAsk:false,
				IsOpen:false,
				AllowOver:false,
				checkedAll:false,
				WeekDays:'',

				//自定义调整
				cuIsOpen:false,
				cuIsAsk:false,
				cuCount:0,
				cuAllowOver:false,
				//按月调整
				moIsOpen:false,
				moIsAsk:false,
				moCount:0,
				moAllowOver:false,
				roomList:[],
				beginSlotExcept:'',
				endSlotExcept:'',
				NumText:'Number of rooms CAN NOT be less than 0',
				moNumText:'Number of rooms CAN NOT be less than 0',
				cuNumText:'Number of rooms CAN NOT be less than 0',
				calendar:{
		        display:"",
		        show:false,
		        zero:true,
		        value:[],
		        lunar:false, //显示农历
		        select:(value)=>{
		            if(!value){
		                this.calendar.show=false;
		                return;
		            }
		            this.beginSlot=value.join('-');
		            this.calendar.value=value;
		            this.calendar2.begin=value;
		            this.calendar3.begin=value;
					this.calendar2.value=value;
					this.calendar3.value=value;
		            this.endSlot='';
		            this.calendar2.show=true;
		            this.calendar.show=false;
		            var end=document.getElementById('dateEnd1');
		            end.focus();
					

		        }
		    },
		    calendar2:{
		        display:"",
		        show:false,
		        zero:true,
		        // begin:'', //默认日期
		        value:[],
		        lunar:false, //显示农历
		        select:(value)=>{
		        	
		            if(!value){
		                this.calendar2.show=false;
		                return;
		            }
		            this.endSlot=value.join('-');
		           
		            this.calendar2.value=value;
		            this.calendar4.end=value;
		            this.calendar3.end=value;
		            this.calendar2.show=false;
		            // this.calendar.display=value.join("-");
		        }
		    },
			calendar3:{
		        display:"",
		        show:false,
		        zero:true,
		        value:[],
		        lunar:false, //显示农历
		        select:(value)=>{
		            if(!value){
		                this.calendar3.show=false;
		                return;
		            }
		            this.beginSlotExcept=value.join('-');
		            this.calendar3.value=value;
		            this.calendar4.begin=value;
					this.calendar4.value=value;
		            this.endSlotExcept='';
		            this.calendar4.show=true;
		            this.calendar3.show=false;
		          
		            var end=document.getElementById('dateEnd2');
		            end.focus();
		            
		        }
		    },
		    calendar4:{
		        display:"",
		        show:false,
		        zero:true,
		        // begin:'', //默认日期
		        value:[],
		        lunar:false, //显示农历
		        select:(value)=>{
		        	
		            if(!value){
		                this.calendar4.show=false;
		                return;
		            }
		            this.endSlotExcept=value.join('-');
		           
		            this.calendar4.value=value;
		            this.calendar4.show=false;
		            // this.calendar.display=value.join("-");
		        }
		    },

		    //自定义调整
		    WeekDays:[
				{
					value:1,
					name:'Mon.',
					checked:true
				},
				{
					value:2,
					name:'Tues.',
					checked:true
				},
				{
					value:3,
					name:'Wed.',
					checked:true
				},
				{
					value:4,
					name:'Thur.',
					checked:true
				},
				{
					value:5,
					name:'Fri.',
					checked:true
				},
				{
					value:6,
					name:'Sat.',
					checked:true
				},
				{
					value:0,
					name:'Sun.',
					checked:true
				},
		    ],
		      //按月调整
		    WeekDays2:[
				{
					value:1,
					name:'Mon.',
					checked:true
				},
				{
					value:2,
					name:'Tues.',
					checked:true
				},
				{
					value:3,
					name:'Wed.',
					checked:true
				},
				{
					value:4,
					name:'Thur.',
					checked:true
				},
				{
					value:5,
					name:'Fri.',
					checked:true
				},
				{
					value:6,
					name:'Sat.',
					checked:true
				},
				{
					value:0,
					name:'Sun.',
					checked:true
				},
		    ],
		    // 时间段调整
		    WeekDays3:[
				{
					value:1,
					name:'Mon.',
					checked:true
				},
				{
					value:2,
					name:'Tues.',
					checked:true
				},
				{
					value:3,
					name:'Wed.',
					checked:true
				},
				{
					value:4,
					name:'Thur.',
					checked:true
				},
				{
					value:5,
					name:'Fri.',
					checked:true
				},
				{
					value:6,
					name:'Sat.',
					checked:true
				},
				{
					value:0,
					name:'Sun.',
					checked:true
				},
		    ]




    	}
    },
    watch:{

    	cmData(val){
			this.data=val;
			
    	},
    	cmroomList(val){
				var that=this;
					that.roomList=val;
					that.roomList.forEach(function(item){
						that.$nextTick(function () {
									that.checkRoomScope(item,true)
						});

    		})
			
    	},
    	checkedAll(val){
    		var that=this;
    		that.roomList.forEach(function(item){
    			that.$nextTick(function () {
		            that.$set(item,'checked',val);
		            that.checkboxChange(item)
		    　　 });

    		})

    	},
			Count(Val) {
				var that = this
				// 移除前导零（但保留单个 0）
				that.Count = Val.replace(/^0+(\d)/, '$1');
				// 处理空值时恢复为 0（可选）
				if (that.Count === '') that.Count = '0';
				if (that.Count < 1) {
						that.NumText = 'Number of rooms CAN NOT be less than 0'
				}else{
						that.NumText = ''
				}
				if (that.Count > 99) {
						that.NumText = 'Number of rooms CAN NOT exceed 100'
				}
			},
			IsAsk(Val) {
				var that = this
				if(!Val){
					if (that.Count < 1) {
							that.NumText = 'Number of rooms CAN NOT be less than 0'
					}
					if (that.Count > 99) {
							that.NumText = 'Number of rooms CAN NOT exceed 100'
					}
				}else{
					that.NumText = ''
				}
			},
			moCount(Val) {
				var that = this
				// 移除前导零（但保留单个 0）
				that.moCount = Val.replace(/^0+(\d)/, '$1');
				// 处理空值时恢复为 0（可选）
				if (that.moCount === '') that.moCount = '0';
				if (that.moCount < 1) {
						that.moNumText = 'Number of rooms CAN NOT be less than 0'
				}else{
						that.moNumText = ''
				}
				if (that.moCount > 99) {
						that.moNumText = 'Number of rooms CAN NOT exceed 100'
				}
			},
			moIsAsk(Val) {
				var that = this
				if(!Val){
					if (that.moCount < 1) {
							that.moNumText = 'Number of rooms CAN NOT be less than 0'
					}
					if (that.moCount > 99) {
							that.moNumText = 'Number of rooms CAN NOT exceed 100'
					}
				}else{
					that.moNumText = ''
				}
			},
			cuCount(Val) {
				var that = this
				// 移除前导零（但保留单个 0）
				that.cuCount = Val.replace(/^0+(\d)/, '$1');
				// 处理空值时恢复为 0（可选）
				if (that.cuCount === '') that.cuCount = '0';
				if (that.cuCount < 1) {
						that.cuNumText = 'Number of rooms CAN NOT be less than 0'
				}else{
						that.cuNumText = ''
				}
				if (that.cuCount > 99) {
						that.cuNumText = 'Number of rooms CAN NOT exceed 100'
				}
			},
			cuIsAsk(Val) {
				var that = this
				if(!Val){
					if (that.cuCount < 1) {
							that.cuNumText = 'Number of rooms CAN NOT be less than 0'
					}
					if (that.cuCount > 99) {
							that.cuNumText = 'Number of rooms CAN NOT exceed 100'
					}
				}else{
					that.cuNumText = ''
				}
			}
    },
    methods:{
	  	lastMonth(){
	  		var now=this.year+'-'+this.month;
	  		if(this.getSearchMonth(now,-1)[0]<this.getYears()[0]){
	  			return;
	  		}
	  		this.month=this.getSearchMonth(now,-1)[1];
	  		this.year=this.getSearchMonth(now,-1)[0];

	  	},
	  	nextMonth(){
			var now=this.year+'-'+this.month;
			if(this.getSearchMonth(now,1)[0]>this.getYears()[4]){
	  			return;
	  		}
	  		this.month=this.getSearchMonth(now,1)[1];
	  		this.year=this.getSearchMonth(now,1)[0];
	  	},
	  	getSearchMonth(dat,count){
	  		var date = new Date(dat);
			
	        date.setMonth(date.getMonth() + count,1);
	        var year = date.getFullYear();
	        var month = date.getMonth() + 1;
	        if (month < 10) { month = '0' + month };
	        month=String(month);
	        return [year,month];
	  	},

    	onDateChange(date){
    		this.DateRangeDates=date;
    	},
		getYears(){
			var da = new Date();
            var year=da.getFullYear();
            var result=[];
            for(var i=0;i<2;i++){
            	result.push(year+i)
            }
			return result;
		},
		getMonth(){
			var da = new Date();
            var month = da.getMonth()+1;
            if(month<10){month='0'+month};
			return month
		},
		checkedAllCancel(){
    		var that=this;
    		this.checkedAll=false;
    		that.roomList.forEach(function(item){
    			that.$nextTick(function () {
		            that.$set(item,'checked',false);
		            that.checkboxChange(item)
		    　　 });

    		})
		},
		//房态范围修改
		checkRoomScope(room,flag){
			var that=this;
			if(flag){
				that.$nextTick(function () {
					that.$set(room,'checked',true);
					// that.$set(room,'scope',true);
					room.RPS.forEach(function(item){
						that.$set(item,'active',true);
						that.$set(item,'scope',true);
						if(room.RPS.length<2){
							that.$set(item,'scope',false);
						}
					})
				});
			}else{
				that.$nextTick(function () {
					// that.$set(room,'scope',false);
					room.RPS.forEach(function(item){
						that.$set(item,'scope',false);
					})
				});
			}
			
		},

	  //全选或者反选酒店
		checkboxChange(room){
			var that=this;
			var status=room.checked;
			that.$nextTick(function () {
	      that.$set(room,'checked',status);
				if(!status){
					that.$set(room,'IsShared',false);
					// that.$set(room,'scope',false);
				}
	    });
			room.RPS.forEach(function(item){
				that.$set(item,'active',status);
				if(!status){
					that.$set(item,'scope',false)
				}
			})
		},
		getEveryDay(s1,count){
			var date = new Date(s1);
            date.setDate(date.getDate() + count); //获取count天后的日期 
            var year = date.getFullYear();
            var month = date.getMonth() + 1;
            var day = date.getDate();
            if (month >= 1 && month <= 9) {
                month = "0" + month;
            }
            if (day >= 0 && day <= 9) {
                day = "0" + day;
            }

            var time = year + '/' + month + '/' + day;
            return time;

		},
		getAllDays(s1,s2){
		
			var count=this.getDaysSize(s1,s2);
			var days=[];
			for(var i=0;i<=count;i++){
				var d=this.getEveryDay(s1,i);
				days.push(d);
			
			}
			return days;

		},
		getAllRps(){
			var list=[];
			var roomList=this.roomList;
			for(var i=0;i<roomList.length;i++){
				
				roomList[i].RPS.forEach(function(item){
					if(item.active){
						var obj={
							HotelID: item.HotelId,
				      RoomID: item.RoomId,
				      RPID: item.RatePlanId,
				      RateID: item.RateId,
							IsShared: roomList[i].IsShared		
						}
						list.push(obj)
					}

				})
			}
			return list;
		},
		calculateFirstAndLastDay(y,m) {
      const year = parseInt(y);
      const month = parseInt(m) - 1; // JavaScript 中月份是从 0 开始的

      // 计算当月第一天
      const firstDay = new Date(year, month, 1);
      const firstDayFormatted = this.formatDate(firstDay);

      // 计算当月最后一天
      const lastDay = new Date(year, month + 1, 0); 
      const lastDayFormatted = this.formatDate(lastDay); 

      // 返回结果对象
      var result = {
        firstDay: firstDayFormatted,
        lastDay: lastDayFormatted
      };

			return result
			
    },
		formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从 0 开始，需要加 1
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    save () {
	    var that=this;
			var DateRange={};
			var params={};//请求参数
		  var WeekDays=[];
			
			if (!that.getAllRps()||that.getAllRps().length<=0){
	            that.error({title: 'Tips',content: 'Please select Hotel rp'})
	            return;
	        }
			//自定义调整
			if(that.isActivePage=='custom'){
				var DateRangeDateslist=JSON.parse(JSON.stringify(that.DateRangeDates))
				if(!DateRangeDateslist){
					that.error({title: 'Tips',content: 'Please select a date'})
					return;
				} 
				if(!that.cuHideRoomCount&&that.cuCount<1&&!that.cuIsAsk){
						that.cuNumText = 'Number of rooms CAN NOT be less than 0'
	    			return;
	    		}
				if(!that.cuHideRoomCount&&that.cuCount>99){
						that.cuNumText = 'Number of rooms CAN NOT exceed 100'
	    			return;
	    		}

				DateRangeDateslist.shift();
				DateRangeDateslist = DateRangeDateslist.sort((a, b) => new Date(a) - new Date(b))
				DateRange={
	                Type: 0,
	                Dates:DateRangeDateslist,
	                WeekDays:null,
	                Excepts:null
	            }
	      params={
							RPs:that.getAllRps(),
			        IsOpen: that.cuIsOpen,
			        IsAsk: that.cuIsAsk,
			        Count: that.cuCount,
			        AllowOver: that.cuIsAsk?false:that.cuAllowOver,
			        DateRange:DateRange,
							IsOnlyChangeRoomStatus:that.cuHideRoomCount,
							IsOnlyChangeStockNum: that.cuHideRoomStatus,
							StartDate:DateRangeDateslist[0],
							EndDate:DateRangeDateslist[DateRangeDateslist.length-1]
		        }
	        //按月调整
			}else if(that.isActivePage=='month'){
				that.WeekDays2.forEach(function(day){
		        	if(day.checked){
						WeekDays.push(day.value)
		        	}
		        })
				if(!that.moHideRoomCount&&that.moCount<1&&!that.moIsAsk){
						that.moNumText = 'Number of rooms CAN NOT be less than 0'
	    			return;
	    		}
				if(!that.moHideRoomCount&&that.moCount>99){
						that.moNumText = 'Number of rooms CAN NOT exceed 100'
	    			return;
	    		}


				var FirstAndLastDay = this.calculateFirstAndLastDay(that.year,that.month)
				DateRange={
	                Type: 1,
	                Year:that.year,
	                Month:that.month,
	                WeekDays: WeekDays,
	                Excepts:''
	            }
	            params={
								RPs:that.getAllRps(),
								IsOpen: that.moIsOpen,
								IsAsk: that.moIsAsk,
								Count: that.moCount,
								AllowOver: that.moIsAsk?false:that.moAllowOver,
								DateRange:DateRange,
								IsOnlyChangeRoomStatus:that.moHideRoomCount,
								IsOnlyChangeStockNum: that.moHideRoomStatus,
								StartDate:FirstAndLastDay.firstDay,
								EndDate:FirstAndLastDay.lastDay
					
		        	}
			//时间段调整
			}else if(that.isActivePage=='timeSlot'){

				if (!that.beginSlot||!that.endSlot){
		            that.error({title: 'Tips',content: 'Please select a date'})
		            return;
		        }
				if(!that.hideRoomCount&&that.Count<1&&!that.IsAsk){
						that.NumText = 'Number of rooms CAN NOT be less than 0'
	    			return;
	    		}
				if(!that.hideRoomCount&&that.Count>99){
						that.NumText = 'Number of rooms CAN NOT exceed 100'
	    			return;
	    		}
		        var allDays=that.getAllDays(that.beginSlotExcept,that.endSlotExcept);
				
				
		        that.WeekDays3.forEach(function(day){
		        	if(day.checked){
						WeekDays.push(day.value)
		        	}
		        })
				DateRange={
	                Type: 2,
	                Start:that.beginSlot,
	                End:that.endSlot,
	                WeekDays: WeekDays,
	                Excepts:allDays
	            }
	            params={
								RPs:that.getAllRps(),
								IsOpen: that.IsOpen,
								IsAsk: that.IsAsk,
								Count: that.Count,
								AllowOver: that.IsAsk?false:that.AllowOver,
								DateRange:DateRange,
								IsOnlyChangeRoomStatus:that.hideRoomCount,
								IsOnlyChangeStockNum: that.hideRoomStatus,
								StartDate: that.beginSlot,
								EndDate: that.endSlot
		        	}
			}

	        that.patchRequest({
	            url: that.Api.batchState,
	            params: JSON.stringify(params)
	        }).then(res => {
	        	
	          
	            if (res&&res.IsSuccess) {
	                that.data.isShow=false;
	                this.$emit('saveDate')
									this.error({ title: 'Tips', content: 'Save successfully' });
	            } else {
	                that.error({ title: 'Tips', content: 'Failed to submit, please try again' });
	            }
	        });
	    },
    },
    mounted(){
    	this.roomList=this.cmroomList;
    	
    }
}
	
</script>


// WEBPACK FOOTER //
// src/components/roomStatus/datePriceTable/roomStatusEdit/RoomStatusBatch.vue